import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { RawMaterialDto} from '@sharedcommon/rest/data.restservice';
import {UserService} from '@sharedcommon/services/user.service';
import {Rights} from '@sharedcommon/util/rights.util';
import {RawmaterialOrSampleService} from '@usercommon/service/rawmaterial-or-sample.service';
import {RmOrSampleMultiModificationStore} from "@usercommon/stores/rm-or-sample-multi-modification.store";
import {RawmaterialOrSampleStatus} from '@sharedcommon/util/rawmaterial-or-sample-status.utils'

@Component({
  selector: 'neq-rawmaterials-additional-actions',
  templateUrl: './rawmaterials-additional-actions.component.html'
})
export class NeqRawmaterialsAdditionalActionsComponent {
  @Output() deleteInput: EventEmitter<any> = new EventEmitter();
  @Input() showDeleteButton: boolean ;
  @Input() rawMaterial: RawMaterialDto;

  public duplicateRight = [ Rights.U_RM_DUP ];

  deleteRight = [Rights.U_MP_DELETE];

  constructor(
    private readonly store: RawmaterialOrSampleService,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly rmMultiModificationStore:RmOrSampleMultiModificationStore
  ) {
  }

  duplicate(): void {
    this.store.setProductIdToDuplicate(this.rawMaterial.id);
    /* Use relative path to make it easy to configure the go back button header
     * in the raw material property page */
    this.router.navigate(['duplicate'], {relativeTo: this.route});
  }

  canDuplicate(): boolean {
    return this.userService.isFeedOperatingMode()
    && this.userService.hasRights(this.duplicateRight)
    && !this.rmMultiModificationStore.isProcessActive()
    && this.rawMaterial.status == RawmaterialOrSampleStatus.ENABLED;
  }

  sendResetInput(): void {
    this.deleteInput.next(null) ;
  }
}
